import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/react';

// Configure native status bar
if (Capacitor.isNativePlatform()) {
  import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
    StatusBar.setStyle({ style: Style.Dark }); // Light text on dark background
    StatusBar.setBackgroundColor({ color: '#060912' }).catch(() => {}); // Android only
    StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {}); // Don't overlap content
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'), {
  // React 19 error hooks — report render errors to Sentry (no-op without a DSN)
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
